module.exports = __webpack_public_path__ + "static/media/about_main_img.e6607c46.png";